import React /*, { useEffect, useState }*/ from "react";
import { Link, useNavigate } from "react-router-dom";
import logoIHF from "../imgs/iury.png";
/*import api from "../utils/api.utils";*/

import "./NavbarAdmin.css";

export const NavbarAdmin = () => {
  const navigate = useNavigate();
  /*
  const [users, setUsers] = useState([]);

  const getUsers = async () => {
    let userId = sessionStorage.getItem("userId");
    try {
      const data = await api.getUserLogged(userId);
      setUsers(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  let isAdmin = false;
  let userName;

  users?.forEach((user) => {
    if (user?.admin) {
      isAdmin = true;
    }
    userName = user.full_name;
    return userName;
  });
*/
  const logout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("userId");
    navigate("/admin/login");
  };
  return (
    <>
      <nav className="nav-admin">
        <div className="container">
          <div className="logo">
            <img src={logoIHF} alt="Logotipo Iury" />
          </div>
          <div className="top-name">
            <Link to="/">Canal de Denúncias</Link>
          </div>
          <ul className="justify-content-end">
            <Link to="/admin/home/" className="link no-mobile">
              <i className="bi bi-house-door-fill"></i>
              <span>HOME</span>
            </Link>
            <Link to="/admin/mailbox/" className="link no-mobile text-center">
              <i className="bi bi-envelope-open"></i>
              <span>MAIL BOX</span>
            </Link>
            <Link to="/admin/tipos/" className="link no-mobile">
              <i className="bi bi-list-task"></i>
              <span>TIPOS</span>
            </Link>
            {/*{isAdmin ? (*/}
            <Link to="/admin/users/" className="link no-mobile">
              <i className="bi bi-people-fill"></i>
              <span>USUÁRIOS</span>
            </Link>
            {/* ) : null}*/}
            <Link to="/admin/login" onClick={logout} className="link no-mobile">
              <i className="bi bi-box-arrow-right"></i>
              <span>SAIR</span>
            </Link>
          </ul>
        </div>
      </nav>
      {/*<div className="container d-flex justify-content-end w-100 p-3 flex-column align-items-end">
        <div className="d-flex justify-content-end">
          <i className="bi bi-person-circle"> </i> &nbsp;
          <span> {userName} </span>
        </div>
       {isAdmin && (
          <span className="btn btn-info d-flex justify-content-end">
            Administrador(a)
          </span>
       )}
      </div>*/}
    </>
  );
};
